export const formatDeltas = (params: any) => ({
  ...params,
  beginDelta:
    params.beginDelta >= 0 ? `+${params.beginDelta}m` : `${params.beginDelta}m`,
  endDelta:
    params.endDelta >= 0 ? `+${params.endDelta}m` : `${params.endDelta}m`,
});
